import React, { useEffect, useState } from "react";
import { version as CURRENT_VERSION } from "../../../package.json";

const VersionChecker = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    const checkVersion = async () => {
      try {
        const res = await fetch(`/meta.json?t=${Date.now()}`, {
          cache: "no-store",
        });
        const data = await res.json();

        if (data.version && data.version !== CURRENT_VERSION) {
          setShowUpdate(true);
        }
      } catch (err) {
        console.error("Version check failed:", err);
      }
    };

    checkVersion(); // Initial check
    const interval = setInterval(checkVersion, 60 * 60 * 1000); // Hourly

    return () => clearInterval(interval);
  }, []);

  const handleReload = () => {
    // Clear any cached data first
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    
    // Force hard reload bypassing cache
    window.location.reload(true);
  };

  if (!showUpdate) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      onClick={handleReload}
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#fff8e1",
        color: "#92400e",
        textAlign: "center",
        padding: "12px",
        zIndex: 9999,
        fontWeight: "bold",
        fontSize: "16px",
        cursor: "pointer",
        boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
      }}
    >
     A new version of Jobvious is available. Click here to refresh.
    </div>
  );
};

export default VersionChecker;